import { useCallback, useEffect, useState } from 'react'

const FAVORITES_KEY = 'bewave:favorites'

const read = (): string[] => {
  try {
    const saved = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]')
    return Array.isArray(saved) ? saved : []
  } catch {
    // localStorage indisponível (modo privado, cookies bloqueados).
    return []
  }
}

/**
 * Favoritar uma escola. Persiste no localStorage por slug — não há conta de
 * visitante, então o favorito vive no navegador.
 *
 * Extraído de SchoolLanding quando o card do diretório passou a favoritar também;
 * os dois precisam ler e escrever a MESMA chave, senão favoritar na listagem não
 * apareceria na página da escola.
 */
export function useFavorite(slug: string | null) {
  const [favorited, setFavorited] = useState(false)

  useEffect(() => {
    if (!slug) return
    setFavorited(read().includes(slug))
  }, [slug])

  const toggle = useCallback(() => {
    if (!slug) return

    setFavorited((prev) => {
      const next = !prev
      try {
        const set = new Set(read())
        if (next) set.add(slug)
        else set.delete(slug)
        localStorage.setItem(FAVORITES_KEY, JSON.stringify([...set]))
      } catch {
        // Sem persistência o estado ainda muda na tela; some ao recarregar.
      }
      return next
    })
  }, [slug])

  return { favorited, toggle }
}
